import React from 'react';
import { SkipToLocationLink } from './SkipToLocationLink';

export const SkipToAccessibilityLink = () => (
  <SkipToLocationLink elementId="a11yHelp">
    Skip to Accessibility Services
  </SkipToLocationLink>
);
